import './archive.scss';

if ($('#ukraine').length) {
  /*global allTerms*/

  let termsData = JSON.parse(allTerms);

  let map = window.AmCharts.makeChart("ukraine", {
    "type": "map",
    "dataProvider": {
      "mapURL": window.location.origin + '/wp-content/themes/euro/resources/assets/images/ukraine.svg',
      "getAreasFromMap": true,
    },
    "areasSettings": {
      "autoZoom": false,
      "color": "#cb912e",
      "rollOverColor": "#E4C370",
      "rollOverOutlineColor": "#E4C370",
      "selectedColor": "#E4C370",
      "selectable": true,
    },
    "dragMap": false,
    "zoomControl": {
      "homeButtonEnabled": false,
      "zoomControlEnabled": false,
    },
    "imagesSettings": {
      "labelColor": "#fff",
      "labelRollOverColor": "#fff",
      "labelPosition": "middle",
      "labelFontSize": 10,
    },
  });


  map.addListener("init", function () {
    setTimeout(function () {

      map.dataProvider.images = [];

      for (let x in map.dataProvider.areas) {

        let area = map.dataProvider.areas[x];
        let termName = '';

        termsData.forEach(function (e) {
          if (area.id === e.slug) {
            termName = e.name;
          }
        });

        let title = termName.split(' ');
        let image = new window.AmCharts.MapImage();

        image.latitude = map.getAreaCenterLatitude(area);
        image.longitude = map.getAreaCenterLongitude(area);
        image.label = title.join("\n");
        image.title = area.title;
        image.id = area.id;
        image.labelPosition = 'middle';
        image.linkToObject = area;

        if (area.id === 'ivano-frankivsk') {
          image.latitude = image.latitude + 0.2;
        }

        map.dataProvider.images.push(image);
      }
      map.validateData();
    }, 100);
  });

  map.addListener('clickMapObject', function (event) {
    let ObjectId = event.mapObject.id;

    termsData.forEach(function (term) {
      if(ObjectId === term.slug) {
        window.location.href = window.location.origin + `/${term.taxonomy}/` + term.slug;
      }
    });

  });


  map.addListener('rollOutMapObject', function(){
    let areas = map.dataProvider.areas;

    for (let i = 0; i < areas.length; i++) {
      map.rollOutMapObject(areas[i]);
    }
  });

  map.addListener('rollOverMapObject', function(event){
    let mapObject = event.mapObject,
      areas = map.dataProvider.areas;

    if (mapObject.cname !== 'MapImage') {
      return;
    }

    var area;
    for (let i = 0; i < areas.length; i++) {
      if ( areas[i].id === mapObject.id ) {
        area = areas[i];
      }
    }

    map.rollOverMapObject(area);
  });
}